"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const TextAreaField_1 = tslib_1.__importDefault(require("./TextAreaField"));
/**
 * @deprecated Use {@link WCAGTextAreaField} with options 'maxLength' instead.
 */
class TextAreaFieldWithCounter extends TextAreaField_1.default {
    setupHandlers(counterElement, limit, template, limitExceededStyle) {
        this.counterElement = counterElement;
        this.limit = limit;
        this.template = template;
        this.limitExceededStyle = limitExceededStyle;
        // Handle updates to value / input
        this.addValueChangeHandler(() => this.updateLiveCounter());
        this.addKeyUpHandler(() => this.updateLiveCounter());
        this.updateLiveCounter();
    }
    setValue(value, fireEvents = false) {
        super.setValue(value, fireEvents);
        this.updateLiveCounter();
    }
    updateLiveCounter() {
        const count = this.getValue().length;
        const counterText = this.template.replace("$count", "" + count).replace("$limit", "" + this.limit);
        this.counterElement.innerText = counterText;
        if (this.limitExceededStyle) {
            if (count > this.limit) {
                this.counterElement.classList.add(this.limitExceededStyle);
            }
            else {
                this.counterElement.classList.remove(this.limitExceededStyle);
            }
        }
    }
}
exports.default = TextAreaFieldWithCounter;
//# sourceMappingURL=TextAreaFieldWithCounter.js.map